export var HomeEmptyBaseModule = {
  code: 'HOME',
  url: null,
  label: 'Inicio',
  submodules: [],
  __typename: 'TalentModuleInfo'
};
export var EmptyTalentModulesArray = [HomeEmptyBaseModule];